// Direktiva na renderovanie menu bonusov pre prihlaseneho hraca
directives.playerBonusDirective.playerBonusesMenu = function() {
    var directive = {
        ".bonus-menu-button": {
            "menuBonusItem<-": {
                ".bonus-status": function() {
                    if (this.status === "available") {
                        return texts.MenuBonusAvailable;
                    } else if (this.status === "in_progress") {
                        return texts.MenuBonusInProgress;
                    }
                },
                ".bonus-status@class+": function() {
                    if (this.status === "no_status" || this.status === "fulfilled" || this.status === "unfulfilled") {
                        return " hide-element";
                    }
                },
                ".bonus-name": function() {
                    if (this.bonusTitle) {
                        return this.bonusTitle;
                    }
                },
                ".bonus-icon": function() {
                    if (this.bonusCount) {
                        return this.bonusCount;
                    }
                },
                ".bonus-icon@class+": function() {
                    if (this.status === "fulfilled" || this.status === "unfulfilled") {
                        return " " + this.status;
                    } else if (this.bonusCount) {
                        return " group-name";
                    }
                },
                ".@bonus-id": function() {
                    if (this.bonusID) {
                        return "bonus-" + this.bonusID;
                    }
                },
                "@onmousedown": function () {
                    if (this.bonusID && this.bonusName && this.bonusType ) {
                        if (this.param && this.bonusType === "PromoCode") {
                            return "player.playerBonusModule.playerBonusDetail(" + this.bonusID + ", '" + this.bonusName + "', '" + this.bonusType + "', " + null + ", '" + this.param + "')";
                        } else if (this.iFrameProgressUrl) {
                            return "player.playerBonusModule.playerBonusDetail(" + this.bonusID + ", '" + this.bonusName + "', '" + this.bonusType + "', '" + this.iFrameProgressUrl + "', '" + this.param + "')";
                        }
                    }
                },
                "@bonus-type": function() {
                    if (this.bonusType) {
                        return this.bonusType;
                    }
                }
            }
        }
    }
    T.playerBonusesMenu = $p("#playerBonusesModal #bonusesList").compile(directive);
};

// Direktiva na renderovanie freebet listu v hrackych bonusoch
directives.playerBonusDirective.playerBonusesFreebetList = function() {
    var directive = {
        "table thead .fb-list-name": function() {
            return texts.FbName;
        },
        "table thead .fb-list-from": function() {
            return texts.FbDateValidTo;
        },
        "table thead .fb-list-sum": function() {
            return texts.FbSum;
        },
        "table thead .fb-list-conditions": function() {
            return texts.FbConditions;
        },
        "table thead .fb-list-status": function() {
            return texts.FbStatus;
        },
        "#freebetsTable tbody": {
            "Row<-": {
                "tr>.fb-list-name": function() {
                    return this.systemFreeBetName;
                },
                "tr>.fb-list-from": function() {
                    this.validToDate = this.validTo.substr(8, 2) + "." + this.validTo.substr(5, 2) + "." + this.validTo.substr(0, 4);
                    this.validToTime = this.validTo.substr(11, 5);
                    return this.validToDate + " " + this.validToTime;
                },
                "tr>.fb-list-sum": function() {
                    return this.amount;
                },
                "tr>.fb-list-conditions": function() {
                    return texts.FbConditionsShow;
                },
                "tr>.fb-list-conditions@onmousedown": function(a) {
                    return "ticket.ticketPromoModule.triggerFBconditions(" + a.pos + ")";
                },
                "tr>.fb-list-conditions@class+": function(a) {
                    return " fb-list-conditions-" + a.pos;
                },
                "tr>.fb-list-status .icon-fb-status@class+": function() {
                    switch (this.status) {
                        case 1:
                            // Dostupna
                            return " icon-check-script-in-circle-fill available";
                        break;
                        case 2:
                            // Pouzita
                            return " icon-check-script-in-circle-fill used";
                        break;
                        case 3:
                            // Exspirovana
                            return " icon-block-stroke-bold";
                        break;
                        case 4:
                            // Neverifikovana
                            return " icon-alert-circle-fill";
                        break;
                        case 5:
                        default:
                            // Zrusena
                            return " icon-x-in-circle-rounded-fill";
                        break;
                    }
                },
                ".collapsible td@class+": function(a) {
                    return " table-conditions-" + a.pos;
                },
                ".collapsible td": function() {
                    this.minRateAll = String().noValueCheck(this.minRateAll, "-");
                    this.minOdds = String().noValueCheck(this.minOdds, "-");
                    this.maxRateAll = String().noValueCheck(this.maxRateAll, "-");
                    this.maxRateOdd = String().noValueCheck(this.maxRateOdd, "-");
                    this.minRateOdd = String().noValueCheck(this.minRateOdd, "-");
                    this.liveRequired? this.liveRequired = texts.FbRequireYes : this.liveRequired = texts.FbRequireNo;
                    this.prematchRequired? this.prematchRequired = texts.FbRequireYes : this.prematchRequired = texts.FbRequireNo;

                    return '<table class="fb-condition"><caption>'
                    + texts.FbConditions + '</caption><tr><th class="min-rate">'
                    + texts.FbMinRateOdd + '</th><td class="min-rate">'
                    + this.minRateAll + '</td><th class="min-odds">'
                    + texts.FbMinOdds + '</th><td class="min-odds">'
                    + this.minOdds + '</td></tr> <tr><th class="max-rate">'
                    + texts.FbMinRateOdd + '</th><td class="max-rate">'
                    + this.maxRateAll + '</td><th class="live-req">'
                    + texts.FbLiveRequired + '</th><td class="live-req">'
                    + this.liveRequired + '</td></tr> <tr><th class="max-odd-rate">'
                    + texts.FbMaxRateAll + '</th><td class="max-odd-rate">'
                    + this.maxRateOdd + '</td><th class="prematch-req">'
                    + texts.FbPrematchRequired + '</th><td class="prematch-req">'
                    + this.prematchRequired + '</td></tr><tr><th class="min-odd-rate">'
                    + texts.FbMinRateAll + '</th><td class="min-odd-rate">'
                    + this.minRateOdd + '</td></tr></table>';
                }
            }
        },
        "#freebetBonusesLegend #fbAvailable .label": function() {
            return texts.PlayerFreebetAvailable;
        },
        "#freebetBonusesLegend #fbAvailable .icon@class+": function() {
            return " icon-check-script-in-circle-fill available";
        },
        "#freebetBonusesLegend #fbUsed .label": function() {
            return texts.PlayerFreebetUsed;
        },
        "#freebetBonusesLegend #fbUsed .icon@class+": function() {
            return " icon-check-script-in-circle-fill used";
        },
        "#freebetBonusesLegend #fbExpired .label": function() {
            return texts.PlayerFreebetExpired;
        },
        "#freebetBonusesLegend #fbExpired .icon@class+": function() {
            return " icon-block-stroke-bold";
        },
        "#freebetBonusesLegend #fbWaitingVerification .label": function() {
            return texts.PlayerFreebetNonVerified;
        },
        "#freebetBonusesLegend #fbWaitingVerification .icon@class+": function() {
            return " icon-alert-circle-fill";
        },
        "#freebetBonusesLegend #fbDisabled .label": function() {
            return texts.PlayerFreebetCanceled;
        },
        "#freebetBonusesLegend #fbDisabled .icon@class+": function() {
            return " icon-x-in-circle-rounded-fill";
        }
    }
    T.playerBonusesFreebetList = $p("#playerBonusesModal #freebetsTableWrapper").compile(directive);
};

// Direktiva na renderovanie aktivacnych bonusov v hracskych bonusoch
directives.playerBonusDirective.playerBonusesActivatingBonus = function() {
    var directive = {
        "table thead .activation-list-amount": function() {
            return texts.BonusActivatingAmount;
        },
        "table thead .activation-list-spend": function() {
            return texts.BonusActivatingSpend;
        },
        "table thead .activation-list-button": function() {
            return "";
        },
        "#activatingBonusesTable tbody": {
            "Row<-": {
                "tr>.activation-list-amount .fancy-amount": function() {
                    if (this.amount) {
                        return this.amount + " " + profile.Currency;
                    }
                },
                "tr>.activation-list-spend": function() {
                    if (this.spend) {
                        return this.spend + " " + profile.Currency;
                    }
                },
                "tr>.activation-list-button .confirm-button": function() {
                    if (this.amount) {
                        return texts.BonusActivatingActiveButton;
                    }
                },
                "tr>.activation-list-button .confirm-button@onmousedown": function() {
                    if (this.amount) {
                        return 'player.playerBonusModule.activatingBonus(' + this.amount + ')';
                    }
                }
            }
        }
    }
    T.playerBonusesActivatingBonus = $p("#playerBonusesModal #activatingBonusesTableWrapper").compile(directive);
};
